var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.025C15.05 23.225 17.3125 20.6815 18.7875 18.3945C20.2625 16.1075 21 14.076 21 12.3C21 9.575 20.1315 7.344 18.3945 5.607C16.6575 3.87 14.526 3.001 12 3C9.474 2.999 7.343 3.868 5.607 5.607C3.871 7.346 3.002 9.577 3 12.3C3 14.075 3.7375 16.1065 5.2125 18.3945C6.6875 20.6825 8.95 23.226 12 26.025ZM12 30C7.975 26.575 4.969 23.394 2.982 20.457C0.995 17.52 0.001 14.801 0 12.3C0 8.55 1.2065 5.5625 3.6195 3.3375C6.0325 1.1125 8.826 0 12 0C15.174 0 17.968 1.1125 20.382 3.3375C22.796 5.5625 24.002 8.55 24 12.3C24 14.8 23.0065 17.519 21.0195 20.457C19.0325 23.395 16.026 26.576 12 30Z",
    fill: "#B11500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 26.025C15.05 23.225 17.3125 20.6815 18.7875 18.3945C20.2625 16.1075 21 14.076 21 12.3C21 9.575 20.1315 7.344 18.3945 5.607C16.6575 3.87 14.526 3.001 12 3C9.474 2.999 7.343 3.868 5.607 5.607C3.871 7.346 3.002 9.577 3 12.3C3 14.075 3.7375 16.1065 5.2125 18.3945C6.6875 20.6825 8.95 23.226 12 26.025ZM14.0774 6.74931H15.462C15.8774 6.74931 16.1543 7.05392 16.1543 7.51085V19.6955C16.1543 20.1524 15.8774 20.457 15.462 20.457H8.53891C8.12353 20.457 7.8466 20.1524 7.8466 19.6955V7.51085C7.8466 7.05392 8.12353 6.74931 8.53891 6.74931H9.92353V5.22623H14.0774V6.74931Z",
    fill: "#B11500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6928 14.3647H11.3081V9.79546H12.6928V14.3647Z",
    fill: "#B11500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6928 17.4108H11.3081V15.8878H12.6928V17.4108Z",
    fill: "#B11500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryMarker);
export default __webpack_public_path__ + "static/media/battery-marker.33fcc9e0bdb20d67fd35d0a139421f5e.svg";
export { ForwardRef as ReactComponent };